import { Route, Routes } from "react-router-dom";
import { TraceListPage } from "./traces/TraceList";
import { TraceDetailPage } from "./traces/TraceDetail";

export function TracesPage() {
  return (
    <Routes>
      <Route index element={<TraceListPage />} />
      <Route path=":traceId" element={<TraceDetailPage />} />
    </Routes>
  );
}
